import React from "react";
import { UiCardTitle } from "../../../components/common/UiCardTitle";
import { UiContentCol, UiContentWr } from "../../../components/common/UiPageElements";
import { UiStepsWizard } from "../../../components/common/UiStepsWizard";
import { UiCol, UiRowContainer } from "../../../components/grid-container/GridContainer";
import incentiveCard from '../../../../../styles/img/incentive-work.jpg';

export const HowtoParticipate = (props) => {

    return (
        <>
            <UiContentWr>
                <UiRowContainer fluid="fluid" className="sb-incentive-process-wrapper">

                  
                        <UiCol lg="12" className={props.className}>
                            <UiContentCol>
                                <UiCardTitle title="How to Participate" />
                                <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.<br />Ut enim ad minim veniam, quis nostrud exercitation ullamco.</p>
                                <UiStepsWizard
                                    wizardData={props.wizardData}
                                />
                            </UiContentCol>
                        </UiCol>
                    
                </UiRowContainer>
            </UiContentWr>
        </>
    )
}